var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatDefaultTransparent = function SvgChatDefaultTransparent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.667 8.333h6.666m-6.666 3.334H10M17.5 10a7.5 7.5 0 0 1-8.56 7.426 59.226 59.226 0 0 0-1.636-.223c-.215-.017-.138-.014-.353-.012a9.974 9.974 0 0 0-.585.033l-1.794.128c-.715.051-1.072.077-1.34-.05a1.125 1.125 0 0 1-.534-.535c-.127-.267-.101-.624-.05-1.339l.128-1.794c.022-.302.032-.453.033-.585.002-.215.005-.138-.012-.353-.01-.132-.08-.633-.223-1.636A7.5 7.5 0 1 1 17.5 10Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatDefaultTransparent);
export default ForwardRef;